import { useEffect, useRef } from 'react'
import type { AnwesenheitslisteView } from '@/core/data/portalViews'
import { PdfRegion, ZOOMED_OUT_PDF_SCALE } from '@/core/components/modal/PdfRegion'
import { useListActionsSink } from '@/core/components/list/listActions'

export function AnwesenheitslisteTab({
  anwesenheitsliste,
  onSign,
}: {
  anwesenheitsliste: AnwesenheitslisteView
  onSign: () => void
}) {
  const signed = anwesenheitsliste.signed
  const pdfPath = anwesenheitsliste.pdfPath ?? null

  const onSignRef = useRef(onSign)
  useEffect(() => {
    onSignRef.current = onSign
  })

  const sink = useListActionsSink()
  useEffect(() => {
    if (!sink || signed) return
    sink({
      actions: [{ id: 'sign', label: 'Unterschreiben', icon: 'i-signature', primary: true }],
      onRun: (id) => {
        if (id === 'sign') onSignRef.current()
      },
    })
    return () => sink(null)
  }, [sink, signed])

  return <PdfRegion
      path={pdfPath}
      loadingLabel="Teilnehmendenliste wird geladen …"
      placeholder="Teilnehmendenliste wird geladen…"
      scaleFactor={ZOOMED_OUT_PDF_SCALE}
    />
}
